import { bootstrapApplication } from '@angular/platform-browser';
import { setScriptKey } from '@progress/kendo-licensing';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.kendoLicenseKey) {
  setScriptKey(environment.kendoLicenseKey);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
